import React, { Component } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withSingleScanSession from '../../common/withSingleScanSession';
import { onGoBack } from '../../common/globals';
import ascIcon from '../../assets/images/asc.png';
import descIcon from '../../assets/images/desc.png';
import {
  getSingleScanSessionData, deleteByPrimaryKey
} from '../../utils/db';

class EditSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editSessionData: [],
      isAscending: false
    };
  }

  _getSessionData = async () => {
    try {
      const { singleScanSession } = this.props;
      const singleData = await getSingleScanSessionData(
        singleScanSession.SessionName, singleScanSession.SessionID
      );
      const sessionID = singleScanSession.SessionName === ''
        ? singleScanSession.SessionID : singleScanSession.SessionName;
      if (singleData.length === 0) {
        this.setState({ editSessionData: singleData, sessionID });
      } else {
        const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        singleData.sort((a, b) => naturalCollator.compare(a.scanDate, b.scanDate)).reverse();
        this.setState({ editSessionData: singleData, sessionID });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSort = () => {
    try {
      const { isAscending } = this.state;
      this.setState({ isAscending: !isAscending }, () => {
        this._onSorting();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSorting = () => {
    const { editSessionData } = this.state;
    this.sortOrder = this.sortOrder !== 'asc' ? 'asc' : 'desc';
    const sort = _.orderBy(editSessionData, 'ScanDate', this.sortOrder);
    this.setState({ editSessionData: sort });
  }

  _onProductDelete = async (inventoryId) => {
    const { setLoader } = this.props;
    if (inventoryId !== undefined) {
      setLoader(true);
      await deleteByPrimaryKey(inventoryId);
      await this._getSessionData();
      setLoader(false);
    }
  }

  _goBack = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._getSessionData();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { editSessionData, isAscending, sessionID } = this.state;
    return (
      <section className="list-section resizer-class">
        <Header
          title="Session Scans"
          goBack={this._goBack}
        />
        <section className="session-scan-section">
          <div className="container">
            <div className="ss-top-block">
              <div className="row">
                <div className="col">
                  <p className="mb-0">{sessionID}</p>
                  <p><small>Products: {editSessionData.length}</small></p>
                </div>

                <div className="col-auto">
                  <Link
                    className={(isAscending === true) ? 'btn input-group-icon-button' : 'btn input-group-icon-button'}
                    onClick={this._onSort}
                  >
                    <img
                      src={isAscending === true ? ascIcon : descIcon}
                      width="32"
                      alt="icon"
                    />
                  </Link>
                </div>
              </div>
            </div>

            {
              editSessionData.length === 0
                && <hr className="line-height" />
            }

            {
                !_.isEmpty(editSessionData) && editSessionData.map((item, key) => (
                  <div className="ss-group-block" key={key}>
                    <div className="row gx-2">
                      <div className="col">
                        <div className="row">
                          <div className="col-6">
                            <p>{item.ProductNo}</p>
                          </div>
                          <div className="col-6">
                            <p>{item.LotNo}</p>
                          </div>
                          <div className="col-12">
                            <p className="text-uppercase">{item.ProductDescription}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-3">
                        <p>{item.ExpireDate !== '' && moment(item.ExpireDate).format('MM/DD/YYYY')}<br />Qty: {item.Qty}</p>
                      </div>
                      <div className="col-auto align-self-center">
                        <button className="btn input-group-icon-button" type="button" onClick={() => this._onProductDelete(item.inventoryId)}>
                          {
                                    item.Submitted === 0
                                      ? <i className="icon-right fas fa-trash" />
                                      : <i className="icon-right fas fa-trash" style={{ visibility: 'hidden' }} />
                                }
                        </button>
                      </div>
                    </div>
                  </div>
                ))
            }

            {/* { */}
            {/*  editSessionData.length === 0 */}
            {/*  && <div>Records not available!</div> */}
            {/* } */}
          </div>
        </section>
      </section>
    );
  }
}

export default withSingleScanSession(withLoader(withNotify(withGoBack(EditSession))));
